import React, { PropsWithChildren } from 'react';
import { EButtonSizes, EButtonVariants } from 'constants/Buttons';
import Button from 'components/atoms/Button';
import { useThemeBreakpoint } from 'hooks/useThemeBreakpoint';
import { Fade, Grid, Modal, Typography } from '@mui/material';
import { EIconTypes } from 'constants/Icons';
import { useTranslations } from 'hooks/useTranslations';
import { colors } from 'theme/colors';
import { CustomModalRoot, ModalContent } from './styles';

interface IFormModal extends PropsWithChildren {
  onClickApprove?: () => void;
  onClickClose: () => void;
  open: boolean;
  title?: string;
  text?: string;
  approveButtonLabel?: string;
  approveButtonIcon?: EIconTypes;
  approveButtonDisabled?: boolean;
  cancelButtonLabel?: string;
  minWidth?: string;
  maxWidth?: string;
}

export const FormModal = ({
  onClickApprove,
  onClickClose,
  open,
  title,
  text,
  approveButtonLabel,
  approveButtonIcon,
  approveButtonDisabled,
  cancelButtonLabel,
  children,
  minWidth,
  maxWidth,
}: IFormModal) => {
  const { t } = useTranslations();
  const { isDesktop } = useThemeBreakpoint();
  return (
    <CustomModalRoot style={{ width: isDesktop ? '50%' : '100%' }}>
      <Modal
        aria-labelledby="transition-modal-title"
        aria-describedby="transition-modal-description"
        open={open}
        onClose={onClickClose}
        closeAfterTransition
        sx={{
          alignContent: 'center',
        }}
      >
        <Fade in={open}>
          <ModalContent
            style={{
              width: isDesktop ? '50%' : '100%',
              minWidth: isDesktop ? minWidth || '780px' : 'auto',
              maxWidth: maxWidth || '780px',
            }}
          >
            {title && (
              <Typography
                variant="h5"
                sx={{
                  fontWeight: 600,
                  paddingBottom: '20px',
                  borderBottom: `1px solid ${colors.gray900}`,
                }}
              >
                {title}
              </Typography>
            )}
            {text && (
              <Typography variant="body1" my={1}>
                {text}
              </Typography>
            )}
            {children}
            <Grid item container xs={12} columnSpacing={1} rowGap={1}>
              <Grid item xs={12} sm={onClickApprove ? 6 : 12}>
                <Button
                  fullWidth
                  label={t(cancelButtonLabel || 'general.cancel.button')}
                  id="cancel"
                  variant={EButtonVariants.outlined}
                  onClick={onClickClose}
                  size={EButtonSizes.small}
                />
              </Grid>
              {onClickApprove && (
                <Grid item xs={12} sm={6}>
                  <Button
                    fullWidth
                    label={t(approveButtonLabel || 'general.save.button')}
                    icon={approveButtonIcon || undefined}
                    id="save"
                    variant={EButtonVariants.contained}
                    onClick={onClickApprove}
                    size={EButtonSizes.small}
                    disabled={approveButtonDisabled}
                  />
                </Grid>
              )}
            </Grid>
          </ModalContent>
        </Fade>
      </Modal>
    </CustomModalRoot>
  );
};
